<template>
  <div class="login">
    <div class="login-logo">
      <a href="/">
        <img src="../assets/logo4.png"/>
      </a>
    </div>
    <div class="container">
      <div class="content-wrapper">
        <div class="content-titel"><translate>MFA Verification Instructions</translate></div>
        <p style="margin: 30px 0 20px;padding: 0 20px;"><translate>If the administrator has opened the team MFA certification, you must bind MFA to log in normally!</translate></p>
        <p style="margin-bottom: 30px">
          <el-button type="primary" class="mfa-btn" @click="bindMfa = true"><translate>Bind Immediately</translate></el-button>
          <el-button class="mfa-btn" @click="onCancelLogin"><translate>Unregister</translate></el-button>
        </p>
      </div>
    </div>
    <div class="copyright clearfix small">
      <div>Copyright 2013-2017 <translate>Shanghai Zhuyun Information Technology Co.,Ltd</translate></div>
      <div>Powered by
        <a href="https://cloudcare.cn/" target="_blank" class="text-primary new-block">cloudcare.cn</a>
      </div>
    </div>

    <!--弹框-->
    <el-dialog :title="changeInfo? attrText.mfaverify : attrText.bingMfa" :visible.sync="bindMfa" class="dialog" @close="onDialogClose()">
      <div class="dialog-content" v-if="changeInfo">
        <p class="text">
          <translate>1.You must install the MFA application on your smart device to continue</translate>
        </p>
        <p class="text">
          <translate>2. Common applications that support MFA on smart devices are </translate><a style="color: #20a0ff;" href="https://promotion.aliyun.com/ntms/mobile.html" target="view_window"><translate>Identity</translate></a><translate>, Microsoft Authenticator, Google Authenticator.</translate>
        </p>
        <p class="text">
          <translate>3.If your account has been shared by multiple people, when you successfully bind MFA, other unbound MFA people will not be able to log in. Other people must also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to scan. In consideration of account security, we recommend that you cancel the multiplayer account.</translate>
        </p>
        <p class="text">
          <translate>4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.</translate>
        </p>
      </div>
      <div class="change-content" v-if="!changeInfo">
        <el-tabs v-model="activeName" type="card" @tab-click="onTabClick">
          <el-tab-pane :label="attrText.scanCode" name="scanGet">
          </el-tab-pane>
          <el-tab-pane :label="attrText.manualInput" name="handleGet">
          </el-tab-pane>
          <el-col :span="13" class="securityNum">
            <p class="tip-text" style="margin-bottom: 20px;"><translate>Please use the MFA application on your smartphone to scan</translate></p>
            <el-form :model="securityNumForm" :rules="rules" ref="securityNum" label-position="top" class="demo-ruleForm">
              <el-form-item :label="attrText.firstCode" prop="firstCode" style="margin-bottom: 20px">
                <el-input class="input-class" v-model="securityNumForm.firstCode" :placeholder="attrText.enterCode"></el-input>
              </el-form-item>
              <el-form-item :label="attrText.secondCode" prop="secondCode">
                <el-input class="input-class" v-model="securityNumForm.secondCode" :placeholder="attrText.enterCode"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10" :offset="1" class="ewm" v-if="activeName === 'scanGet'">
            <img :src='securityNumForm.mfaEwm' alt="">
          </el-col>
          <el-col class="hand-get handle" :span="10" :offset="1" v-if="activeName === 'handleGet'">
            <p><translate>Authentication information</translate></p>
            <p><translate>user name</translate>: {{secret.account}}</p>
            <p><translate>Key</translate>: {{secret.secret}}</p>
            <p><translate>Please enter the above information manually in the MFA application to obtain the security code</translate></p>
          </el-col>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer" v-if="changeInfo">
        <el-button type="primary" @click="onChangeInfo()"><translate>Confirm</translate></el-button>
        <el-button @click="bindMfa = false"><translate>Close</translate></el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!changeInfo">
        <el-button type="primary" @click="onConfirmOpen()"><translate>Confirm To Open</translate></el-button>
        <el-button @click="bindMfa = false;changeInfo = true"><translate>Close</translate></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import STORE_CONST from '../store/consts'
  import { baseUrl } from '../config'
  export default{
    data () {
      return {
        bindMfa: false,
        changeInfo: true,
        activeName: 'scanGet',
        securityNumForm: {
          mfaEwm: '',
          firstCode: '',
          secondCode: ''
        },
        secret: {},
        rules: {
          firstCode: [
            {
              required: true,
              pattern: /^\d{6}$/,
              message: this.$gettext('Enter the 6-digit security code'),
              trigger: 'blur'
            }
          ],
          secondCode: [
            {
              required: true,
              pattern: /^\d{6}$/,
              message: this.$gettext('Enter the 6-digit security code'),
              trigger: 'blur'
            }
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    methods: {
      getTranslateText () {
        return {
          'firstCode': this.$gettext('First column verification code'),
          'secondCode': this.$gettext('Second column verification code'),
          'enterCode': this.$gettext('Enter the 6-digit security code'),
          'mfaverify': this.$gettext('MFA Verification Instructions'),
          'scanCode': this.$gettext('Scan the two-dimensional code'),
          'manualInput': this.$gettext('Manual input'),
          'bingMfa': this.$gettext('Bind Mfa')
        }
      },
      onChangeInfo () {
        this.changeInfo = false
        this.securityNumForm.firstCode = ''
        this.securityNumForm.secondCode = ''
        this.activeName = 'scanGet'
        this.secret = ''
        this.securityNumForm.mfaEwm = baseUrl.apiUrl + '/mfa/img' + '?' + Math.random()
      },
      onDialogClose () {
        this.bindMfa = false
        this.changeInfo = true
      },
      // 取消登录
      onCancelLogin () {
        this.$store.dispatch(STORE_CONST.ACCOUNT.LOGOUT).then(res => {
          this.$router.push('/login')
        })
      },
      onTabClick (tab) {
        this.activeName = tab.name
        if (this.activeName === 'handleGet' && !this.secret) {
          // get mfa secret code
          this.$store.dispatch(STORE_CONST.ACCOUNT.GET_MFA_SECRET).then(res => {
            this.secret = res
          })
        }
        this.resetForm('securityNum')
        this.securityNumForm.firstCode = ''
        this.securityNumForm.secondCode = ''
      },
      onConfirmOpen () {
        this.$refs['securityNum'].validate((valid) => {
          if (valid) {
            let params = {
              data: {
                first_code: this.securityNumForm.firstCode,
                second_code: this.securityNumForm.secondCode,
                otp_enabled: 1
              }
            }
            this.$store.dispatch(STORE_CONST.ACCOUNT.POST_MFA_CODE, params).then(res => {
              this.$router.push('/mfaComfirm')
              this.$notify({
                type: 'success',
                message: this.$gettext('Open success!')
              })
              this.bindMfa = false
              this.changeInfo = true
            })
          } else {
            return false
          }
        })
      },
      // reset form
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import '../assets/css/variable.scss';

  .login {
    .container {
      .mfa-btn {
        padding: 10px 55px;
      }
    }
    .el-dialog {
      /*top: 33% !important;*/
      .el-dialog__body{
        padding: 15px 20px;
      }
    }
    .dialog {
      text-align: left;
      .dialog-content {
        padding: 20px 0;
        border-top: 1px solid $border-color;
        border-bottom: 1px solid $border-color;
        .text {
          margin-top: 8px;
        }
      }
      .change-content{
        .securityNum {
          .el-form-item {
            .el-form-item__label {
              &:before {
                content: '*';
              }
            }
          }
        }
        .el-tabs__header{
          padding: 0;
        }
        .ewm{
          text-align: center;
          margin-top: 15px;
          /*<!--border-left: 1px solid $border-color;-->*/
          img{
            width: 75%;
          }
        }
        .handle{
          padding-left: 20px 0 20px 20px;
          /*<!--border-left: 1px solid $border-color;-->*/
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// mfaOpen.vue?64e2987d